module.exports = __webpack_public_path__ + "static/media/yunhaojingpin.e21d1476.png";